import { Store } from 'laco'

const colorState = new Store({
  primary: '#f00',
  secondary: '#6BA314',
  background: '#fff',
  background600: '#fff',
  background700: '#F8F8F8',
  background800: '#eef0f1',
  background900: '#e3e6e8',
  backgroundInverted: '#6a7581',
  borderColor: '#E7E7E7',
  text: '#000',
  textLight: '#535353',
  textOnPrimary: '#fff',
  textPrimary: '#FF0000',
  textInverted: '#ddd',
  blueText: '#5E8CB1',
  blue: '#2F76FF',
  red: '#FD0400',
  redMuted: '#e8413f',
  green: '#6BA314',
  darkGreen: '#006400'
})

const layoutStore = new Store({
  maxWidth: '1200px',
  breakpoints: {
    mobile: '800px',
    tablet: '1200px'
  }
})
const styleStore = new Store({
  borderRadius: '8px'
})

let colors = colorState.get()

let layout = layoutStore.get()

let styles = styleStore.get()

colorState.subscribe(() => {
  colors = colorState.get()
})
layoutStore.subscribe(() => {
  layout = layoutStore.get()
})
styleStore.subscribe(() => {
  styles = styleStore.get()
})

export { colorState, layoutStore, styleStore, colors, layout, styles }

export * from '../../shared/constants'
